import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';
import instagramIcon from '../../../assets/svg/icon/hive-instagram.svg';
import magnifierIcon from '../../../assets/svg/icon/hive-magnifier.svg';
import heartIcon from '../../../assets/svg/icon/hive-heart.svg';
import trendingIcon from '../../../assets/svg/icon/hive-trending-up.svg';
import './HiveInfoBlock.css';

const items = [
  {
    stat: '92%',
    text: 'of users take immediate action searching Google, visiting a location, or making a purchase after watching a platform-native short-form video.',
    icon: instagramIcon,
    iconClass: 'hive-info-icon-instagram',
    alt: 'Social video engagement',
    key: 'stat-92',
  },
  {
    stat: '40%+',
    text: 'of consumers now use TikTok and Instagram as their primary search engine for local recommendations, reviews, and how-tos.',
    icon: magnifierIcon,
    iconClass: 'hive-info-icon-magnifier',
    alt: 'Social search behaviour',
    key: 'stat-40',
  },
  {
    stat: '2X',
    text: 'higher engagement and up to 30% lower acquisition costs across TikTok & Reels prove creator-led content works, yet costs & agency retainers keep it out of reach for SMEs.',
    icon: heartIcon,
    iconClass: 'hive-info-icon-heart',
    alt: 'Creator-led content performance',
    key: 'stat-2x',
  },
  {
    stat: '+157%',
    text: 'more organic search traffic & 80% more Local Inquiries. Connecting indexed short-form video to your Google Search, Maps, and Business Profile turns passive social views into active, high-intent customer leads.',
    icon: trendingIcon,
    iconClass: 'hive-info-icon-trending',
    alt: 'Organic search growth',
    key: 'stat-157',
  },
];

const HiveInfoItem = ({ stat, text, icon, iconClass, alt }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const animationProps = useSpring({
    transform: inView ? 'scale(1)' : 'scale(0.9)',
    opacity: inView ? 1 : 0,
    config: { tension: 170, friction: 20 },
  });

  return (
    <animated.article ref={ref} style={animationProps} className="hive-info-item">
      <div className={`hive-info-icon ${iconClass}`}>
        <img src={icon} alt={alt} />
      </div>
      <p className="hive-info-stat">{stat}</p>
      <p className="hive-info-text">{text}</p>
    </animated.article>
  );
};

const HiveInfoBlock = () => {
  return (
    <div className="hive-info-block">
      {items.map(item => (
        <HiveInfoItem key={item.key} {...item} />
      ))}
    </div>
  );
};

export default HiveInfoBlock;
